import { render, staticRenderFns } from "./AdminViewQuilty.vue?vue&type=template&id=990da32a&"
import script from "./AdminViewQuilty.vue?vue&type=script&lang=ts&"
export * from "./AdminViewQuilty.vue?vue&type=script&lang=ts&"
import style0 from "./AdminViewQuilty.vue?vue&type=style&index=0&id=990da32a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports